module.exports = __webpack_public_path__ + "img/premium_inactive.beea4002.png";